import { FALLBACK_SRC } from "./assetUtils";
import type { BrandKitField } from "@/types/onboarding";

const operationFieldDefinitions: BrandKitField[] = [
  {
    id: "heroBanner",
    dsKey: "banner_message",
    property: "text",
    selector: ".bk-banner-text",
    label: "Promo banner message",
    field: {
      type: "text",
      defaultValue: "E.g. “Free shipping”",
    },
    value: "",
    category: {
      id: "promoBanner",
      dsKey: "banner",
      label: "Top hero promo banner",
    },
  },
  // {
  //   id: "heroAsset",
  //   property: "src",
  //   selector: ".bk-banner-icon",
  //   label: "Hero image",
  //   field: {
  //     type: "text",
  //     defaultValue: FALLBACK_SRC,
  //   },
  //   value: FALLBACK_SRC,
  //   category: {
  //     id: "promoBanner",
  //     label: "Top hero promo banner",
  //   },
  // },
  {
    id: "title",
    dsKey: "value_prop_title",
    property: "text",
    selector: ".bk-value-prop-title",
    label: "Title",
    field: {
      type: "text",
      defaultValue: "E.g. The Value We Deliver",
    },
    value: "",
    category: {
      id: "containers",
      dsKey: "value_props",
      label: "Value proposition",
    },
  },
  {
    id: "containers[i].title",
    dsKey: "title",
    property: "text",
    selector: ".bk-value-prop-[i]-title",
    label: "Title",
    field: {
      type: "text",
      defaultValue: "Enter title",
    },
    value: "",
    category: {
      id: "containers",
      dsKey: "value_props",
      label: "Value proposition",
    },
  },
  {
    id: "containers[i].body",
    dsKey: "body",
    property: "text",
    selector: ".bk-value-prop-[i]-body",
    label: "Body",
    field: {
      type: "text",
      defaultValue: "Enter body",
    },
    value: "",
    category: {
      id: "containers",
      dsKey: "value_props",
      label: "Value proposition",
    },
  },
  {
    id: "containers[i].asset",
    dsKey: "icon",
    property: "src",
    selector: ".bk-value-prop-[i]-icon",
    label: "Icon",
    field: {
      type: "text",
      defaultValue: FALLBACK_SRC,
    },
    value: FALLBACK_SRC,
    category: {
      id: "containers",
      dsKey: "value_props",
      label: "Value proposition",
    },
  },
  {
    id: "socials[i].name",
    dsKey: "name",
    property: "text",
    selector: ".bk-socials-[i]",
    label: "Name",
    field: {
      type: "text",
      defaultValue: "E.g. “Facebook”",
    },
    value: "",
    category: {
      id: "socials",
      dsKey: "socials",
      label: "Socials",
    },
  },
  {
    id: "socials[i].url",
    dsKey: "url",
    property: "href",
    selector: ".bk-socials-[i]",
    label: "Link",
    field: {
      type: "text",
      defaultValue: "URL starting with “https”",
    },
    value: "",
    category: {
      id: "socials",
      dsKey: "socials",
      label: "Socials",
    },
  },
  {
    id: "socials[i].asset",
    dsKey: "icon",
    property: "src",
    selector: ".bk-socials-[i]",
    label: "Icon",
    field: {
      type: "text",
      defaultValue: FALLBACK_SRC,
    },
    value: FALLBACK_SRC,
    category: {
      id: "socials",
      dsKey: "socials",
      label: "Socials",
    },
  },
  {
    id: "messagingDisclaimer",
    dsKey: "messaging_disclaimer",
    property: "text",
    selector: ".bk-disclaimer",
    label: "Disclaimer text (only displayed if there’s an offer)",
    field: {
      type: "text",
      defaultValue: "Enter disclaimer text",
    },
    value: "",
    category: {
      id: "messaging",
      dsKey: "footer",
      label: "Messaging",
    },
  },
  {
    id: "messagingTerms",
    dsKey: "messaging_terms",
    property: "text",
    selector: ".bk-terms",
    label: "Terms & Conditions",
    field: {
      type: "text",
      defaultValue: "Enter Terms & Conditions text",
    },
    value: "",
    category: {
      id: "messaging",
      dsKey: "footer",
      label: "Messaging",
    },
  },
  {
    id: "messagingAdditional",
    dsKey: "messaging_additional",
    property: "text",
    selector: ".bk-additional-message",
    label: "Additional text",
    field: {
      type: "text",
      defaultValue: "Enter text",
    },
    value: "",
    category: {
      id: "messaging",
      dsKey: "footer",
      label: "Messaging",
    },
  },
  // {
  //   id: "messagingFreeShipping",
  //   property: "text",
  //   selector: ".bk-free-shipping",
  //   label: "Free shipping message",
  //   field: {
  //     type: "text",
  //     defaultValue: "Free shipping on all orders",
  //   },
  //   value: "Free shipping on all orders",
  //   category: {
  //     id: "messaging",
  //     label: "Messaging",
  //   },
  // },
  {
    id: "informationName",
    dsKey: "brand_name",
    property: "text",
    selector: ".bk-brand-name",
    label: "Brand name",
    field: {
      type: "text",
      defaultValue: "Your Brand Name",
    },
    value: "Your Brand Name",
    category: {
      id: "information",
      dsKey: "information",
      label: "Company information",
    },
  },
  {
    id: "informationEmail",
    dsKey: "brand_email",
    property: "text",
    selector: ".bk-brand-email",
    label: "Support email (optional)",
    field: {
      type: "text",
      defaultValue: "E.g. “support@yourbrand.com”",
    },
    value: "",
    category: {
      id: "information",
      dsKey: "information",
      label: "Company information",
    },
  },
  {
    id: "informationAddress",
    dsKey: "brand_address",
    property: "text",
    selector: ".bk-address",
    label: "Enter physical address",
    field: {
      type: "text",
      defaultValue: "E.g. “123 Main Street, NY”",
    },
    value: "",
    category: {
      id: "information",
      dsKey: "information",
      label: "Company information",
    },
  },
  {
    id: "informationPhone",
    dsKey: "brand_phone",
    property: "text",
    selector: ".bk-brand-phone",
    label: "Phone number (optional)",
    field: {
      type: "text",
      defaultValue: "E.g. “000-000-000”",
    },
    value: "",
    category: {
      id: "information",
      dsKey: "information",
      label: "Company information",
    },
  },
  {
    id: "groupings[i].name",
    dsKey: "name",
    property: "text",
    selector: ".bk-top-cat-[i]-button",
    label: "Name",
    field: {
      type: "text",
      defaultValue: "E.g. My Top Category",
    },
    value: "",
    category: {
      id: "groupings",
      dsKey: "top_categories",
      label: "Top categories",
    },
  },
  {
    id: "groupings[i].url",
    dsKey: "url",
    property: "href",
    selector: ".bk-top-cat-[i]-button",
    label: "Link",
    field: {
      type: "text",
      defaultValue: "URL starting with “https”",
    },
    value: "",
    category: {
      id: "groupings",
      dsKey: "top_categories",
      label: "Top categories",
    },
  },
  {
    id: "currencySymbol",
    dsKey: "currency_symbol",
    property: "text",
    selector: ".bk-currency-symbol",
    label: "Enter currency",
    field: {
      type: "text",
      defaultValue: "E.g. $",
    },
    value: "$",
    category: {
      id: "currency",
      dsKey: "currency",
      label: "Currency",
    },
  },
  {
    id: "currencyFormat",
    dsKey: "currency_format",
    property: "text",
    selector: ".bk-currency-format",
    label: "Number format",
    field: {
      type: "select",
      options: [
        { id: "period", label: "1,234.56" },
        { id: "comma", label: "1.234,56" },
      ],
      defaultValue: "period",
    },
    value: "period",
    category: {
      id: "currency",
      dsKey: "currency",
      label: "Currency",
    },
  },
  {
    id: "currencySymbolPosition",
    dsKey: "currency_symbol_position",
    property: "text",
    selector: ".bk-currency-symbol-position",
    label: "Symbol position",
    field: {
      type: "select",
      options: [
        { id: "prefix", label: "$100" },
        { id: "suffix", label: "100 €" },
      ],
      defaultValue: "prefix",
    },
    value: "prefix",
    category: {
      id: "currency",
      dsKey: "currency",
      label: "Currency",
    },
  },
];

export default operationFieldDefinitions;
